import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getMultidietCateringsByTier } from "@/features/multidiet/api/get-multidiet-caterings";
import type {
  MultidietCateringsTierType,
  MultidietCateringsType,
} from "@/features/multidiet/types/multidiet-caterings.type";

type UseMultidietCateringsParams = {
  params?: RequestInit;
  tier: MultidietCateringsTierType;
  options?: Omit<
    UseQueryOptions<
      MultidietCateringsType[],
      unknown,
      MultidietCateringsType[],
      string[]
    >,
    "queryFn" | "queryKey"
  >;
};

export const useGetMultidietCaterings = ({
  params,
  tier,
  options,
}: UseMultidietCateringsParams) => {
  return useQuery({
    queryKey: ["multidiet-caterings", JSON.stringify(tier)],
    queryFn: () => getMultidietCateringsByTier({ params, tier }),
    ...options,
  });
};
